// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aWjo","top":"styles_top__ZvAJA","left":"styles_left__1YtA8","description":"styles_description__2JbQC"};